import styled from "@emotion/styled";
import { Button, Form, Input, message, Modal, Select, Typography } from "antd";
import { FC, useEffect, useState } from "react";
import OrderTableList from "./OrderTableList";
import { AudioOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  getMasterTransportByIdData,
  ParkinglistInput,
  ParkingLists,
  ParkingListItems,
} from "services/interface";
import DescriptionForm from "./DescriptionForm";
import {
  useCreateParking,
  useDeleteParking,
  useGetParkingById,
  useGetParkingList,
  useUpdateParking,
} from "hooks/useShipping";
import { useAppSelector } from "store";
import Search from "antd/es/input/Search";
import dayjs from "dayjs";
import TransportSeleect from "./TransportSeleect";
const { Option } = Select;

interface TableParkingProps {
  data: getMasterTransportByIdData | undefined;
  parkingList: ParkingLists[] | undefined;
  setParkingListInput: React.Dispatch<React.SetStateAction<ParkinglistInput[]>>;
}

const TableParking: FC<TableParkingProps> = ({
  data,
  parkingList,
  setParkingListInput,
}) => {
  const [showDetail, setShowDetail] = useState(false);
  const [updateDetail, setUpdateDetail] = useState(false);

  const [updateProvince, setUpdateProvince] = useState<number>(0);

  const [parkingListItem, setParkingListItem] = useState<ParkingLists[]>([]);

  const [parkingSelect, setParkingSelect] = useState<ParkingLists>();

  const { mutate } = useGetParkingList();

  const [form] = Form.useForm();

  const [formUpdate] = Form.useForm();

  const factoryId = useAppSelector(
    (state) => state.auth.profile?.user?.role?.ref_id
  );

  const { mutate: CreateParking } = useCreateParking();
  const { mutate: DeleteParking } = useDeleteParking();
  const { mutate: UpdateParking } = useUpdateParking();
  const { mutate: ParkingById } = useGetParkingById();

  const onCloseUpdate = () => {
    // formUpdate.resetFields();
    setUpdateDetail(false);
  };

  const onCloseModal = () => {
    form.resetFields([
      "province_address_id",
      "district_address_id",
      "parking_id",
      "delivery_name",
      "province_name_th",
      "district_name_th",
    ]);
    // form.setFieldsValue({
    //   timeList: [{ time: undefined }],
    // });
    setShowDetail(false);
  };

  useEffect(() => {
    if (data) {
      //getParkingList(data.id);

      setParkingListItem(parkingList || []);

      // form.setFieldsValue({
      //   timeList: [{ time: undefined }],
      // });
    }
  }, [data]);

  const getTimeList = (times: string | null) => {
    const time = times?.replace("[", "").replace("]", "").split(",");
    console.log(time);
    return time || [];
  };

  const onFinish = (values: any) => {
    console.log(values);

    //conver time to string[]

    let timeList: string[] = [];
    if (values.timeList && values.timeList.length > 0) {
      values.timeList.map((item: any) => {
        timeList.push(item.time.format("HH:mm"));
      });
    }

    //   {
    //     "province_address_id": 1,
    //     "district_address_id": 1001,
    //     "parking_id": "510a311b-7870-4c19-8e3f-c368e5d9452c",
    //     "timeList": [
    //         {
    //             "time": "2024-10-15T17:30:14.056Z"
    //         },
    //         {
    //             "time": "2024-10-15T17:40:18.992Z"
    //         }
    //     ]
    // }

    

    setParkingListItem((prev) => {
      return [
        ...prev,
        {
          parking_id: values.parking_id,
          province_id: values.province_address_id,
          district_id: values.district_address_id,
          times: timeList.length > 0 ? timeList.toString() : "",
          latitude: 0,
          longitude: 0,
          transport_id: data?.id || "",
          parking_name: values.delivery_name,
          district_name_en: "",
          district_name_th: values.district_name_th,
          province_name_en: "",
          province_name_th: values.province_name_th,
        },
      ];

      // CreateParking(
      //   {
      //     factory_id: factoryId || "",
      //     master_transport_id: data?.id || "",
      //     name: values.name,
      //     times: timeList.toString(),
      //     province_id: values.province_id,
      //     district_id: values.district_id,
      //   },
      //   {
      //     onSuccess: (res) => {
      //       if (res.status === "success") {
      //         message.success("สร้างสำเร็จ");

      //         onCloseModal();
      //       } else {
      //         message.error(`สร้างไม่สำเร็จ: ${res.error_message}`);
      //       }
      //     },
      //     onError: (error) => {
      //       message.error(`สร้างไม่สำเร็จ: ${error.message}`);
      //     },
      //   }
      // );
    });
    onCloseModal();
  };

  const onDeleteData = (parkingId: string) => {
    setParkingListItem((prev) => {
      return prev.filter((item) => item.parking_id !== parkingId);
    });
  };

  const onEditData = (parkingId: string) => {
    setParkingSelect(
      parkingListItem.find((item) => item.parking_id === parkingId)
    );
    setUpdateDetail(true);
  };

  const onFinishUpdate = (values: any) => {
    console.log(values);
    //conver time to string[]
    let timeList: string[] = [];
    values.timeList.map((item: any) => {
      timeList.push(item.time.format("HH:mm"));
    });

    setParkingListItem((prev) => {
      return prev.map((item) => {
        if (item.parking_id === values.parking_id) {
          return {
            parking_id: values.parking_id,
            province_id: values.province_address_id,
            district_id: values.district_address_id,
            times: timeList.toString(),
            latitude: 0,
            longitude: 0,
            transport_id: data?.id || "",
            parking_name: values.delivery_name,
            district_name_en: "",
            district_name_th: values.district_name_th,
            province_name_en: "",
            province_name_th: values.province_name_th,
          };
        }
        return item;
      });
    });

    onCloseUpdate();
  };

  useEffect(() => {
    if (parkingListItem) {
      let parkingListInput: ParkinglistInput[] = [];
      parkingListItem.map((item) => {
        parkingListInput.push({
          parking_id: item.parking_id,
          province_id: item.province_id,
          district_id: item.district_id,
          name: item.parking_name,
          times: item.times,
        });
      });

      setParkingListInput(parkingListInput);
    }
  }, [parkingListItem]);

  return (
    <>
      <div>
        <WrapperAll>
          <HeadWrapper>
            <Typography.Title level={5}>จุดจอด</Typography.Title>
            <ButtonWrapper>
              <StyledButton
                type="primary"
                onClick={() => {
                  setShowDetail(true);
                }}
                //disabled={!data}
              >
                <PlusOutlined /> เพิ่มจุดจอด
              </StyledButton>
            </ButtonWrapper>
          </HeadWrapper>
          <div style={{ marginBottom: 10 }}></div>
          <OrderTableList
            data={parkingListItem}
            onDeleteData={onDeleteData}
            onEditData={onEditData}
          />
        </WrapperAll>

        <Modal
          title="เพิ่มจุดจอด"
          open={showDetail}
          maskClosable={false}
          onCancel={() => {
            onCloseModal();
          }}
          // onOk={() => form.submit()}
          style={{ top: 20 }}
          footer={[
            <Button key="back" onClick={() => onCloseModal()}>
              ยกเลิก
            </Button>,
            <Button key="submit" type="primary" onClick={() => form.submit()}>
              บันทึก
            </Button>,
          ]}
        >
          <WrapperAll>
            <Form
              form={form}
              onFinish={onFinish}
              labelAlign="left"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <TransportSeleect formTransport={form} />
            </Form>
          </WrapperAll>
        </Modal>

        <Modal
          title="แก้ไขจุดส่งสินค้า"
          open={updateDetail}
          maskClosable={false}
          onCancel={() => {
            onCloseUpdate();
          }}
          // onOk={() => form.submit()}
          style={{ top: 20 }}
          footer={[
            <Button key="back" onClick={() => onCloseUpdate()}>
              ยกเลิก
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => formUpdate.submit()}
            >
              บันทึก
            </Button>,
          ]}
        >
          <WrapperAll>
            <Form form={formUpdate} onFinish={onFinishUpdate}>
              <TransportSeleect
                formTransport={formUpdate}
                parkingSelect={parkingSelect}
              />
            </Form>
          </WrapperAll>
        </Modal>
      </div>
    </>
  );
};

export default TableParking;

const StyledButton = styled(Button)`
  margin-right: 5px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
`;

const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0px 10px 0px 10px;
  margin-bottom: 10px;
  margin-top: 10px;

  & > :first-child {
    flex: 3;
  }

  & > :last-child {
    flex: 7;
    display: flex;
    justify-content: flex-end;
  }
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
